import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LoginService } from '../../Services/login.service';
import { QuoteService } from 'src/app/Modules/motor/Modules/quote/Services/quote.service';
@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.css']
})
export class UserProfileComponent implements OnInit {

  constructor(public dialog: MatDialog,public loginservice:LoginService,private quoteService:QuoteService) { }
agentName:string;
emailId:string;
//dob:string;
userType:string;
agentId:string;
mobileNo : String;
name:String;
name1:string;
type:String;
  ngOnInit() {
    
   //added by durga.b for  view profile
   var userName = sessionStorage.getItem("userName");
   this.loginservice.viewprofile(userName).subscribe((res: any)=>{
    if(res.responseBody){
      this.agentName= res.responseBody.profilelist["0"].agentName;
      this.agentId = res.responseBody.profilelist["0"].agentId;
      this.name=res.responseBody.profilelist["0"].name;
      this.emailId=res.responseBody.profilelist["0"].emailId;
      this.mobileNo =res.responseBody.profilelist["0"].mobileNo;
      if(res.responseBody.profilelist["0"].userType=="AGN"){
        this.userType="AGENT";
        this.type="0";
      }
      else{
        this.userType=res.responseBody.profilelist["0"].userType;
        if(this.userType =="CSR"){
        this.type="1";
        }
      }
      
if(this.userType =="Admin"){
  this.name1  = "Admin Name";
}else {
  this.name1  = "Agent Name";
}
    } 
  }); 

     //to unlock the QQ
     
     var unlock = sessionStorage.getItem('LOCK');
     if(unlock =="L"){
       
       var userName =sessionStorage.getItem('userName');
       this.quoteService.unlockQuotedetails(userName).subscribe((data:any)=>{
         
         console.log(data);
       })
     }
   //END
  }



}
